import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const Container = ({ className, children }) => (
  <div className={`${className} container`}>{children}</div>
);

Container.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container/index.js